import 'echarts/lib/chart/scatter';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { merge } from 'lodash';

import ChartService from './ChartService';
import { isTextWithinLimit, splitSentanceToWords, splitWordsToLines, trimDotEnd } from './chartCommon';

export default class ChartScatterService extends ChartService {

  buildChartData(visualization, isEditMode, bndBox) {
    const r = 0.05;
    const labels = Object.keys(visualization.data).reverse();
    let data = labels.flatMap((key, ind) => visualization.data[key].map((f) => [f[0], ind + 1, f[1], { label: key, value: f[0] }]));

    let maxX = Math.ceil(data.map((f) => f[0]).max() / 0.1) * 0.1;
    let minX = Math.floor(data.map((f) => f[0]).min() / 0.1) * 0.1;
    let deltaX = maxX - minX;
    if (deltaX <= 0.2) {
      maxX += 0.1 - deltaX / 2;
      minX -= 0.1 - deltaX / 2;
      deltaX = maxX - minX;
    }
    const divider = r / (bndBox.width / 100 / deltaX);

    let groupFnc = (val) => Math.floor((val + divider / 2) / divider) * divider;
    const grouped = data.groupBy(f => labels[f[1] - 1] + '-' + groupFnc(f[0]));
    grouped.forEach(f => f.items[0] = groupFnc(f[0]) + divider / 4);
    // Object.keys(grouped).forEach((key) => grouped[key].forEach((f) => f[0] = groupFnc(f[0]) + divider / 4));

    const mnY = r / (0.0175 * bndBox.height) * labels.length;
    const max = Math.round(0.45 / mnY);
    const fncX = (ind) => {
      const xAdds = [0, 0.5, -0.5, 0.25, -0.25, 0.125, -0.125, 0.375, -0.375];
      const add = Math.floor(ind / max);
      return (xAdds[add] || 0) * 0.5 * divider;
    };
    const fncY = (ind) => {
      ind = ind % max;
      return mnY * (ind * (ind % 2 ? -1 : 1) - ind % 2);
    };
    data = grouped.map(f => f.items).flatMap((f) => f.map((g, ind) => [g[0] + fncX(ind), g[1] + fncY(ind) + (!(f.length % 2) ? mnY : 0), g[2], { ...g[3], group: groupFnc(g[0]) }]));

    const options = {
      grid: {
        bottom: '2%',
        containLabel: true,
        left: '5%',
        right: '5%',
        top: '10%',
      },
      series: [{
        symbolSize: r * 100,
        itemStyle: {
          color(dat) {
            const blue = Math.round((1 - dat.value[2]) * 255);
            const red = Math.round(dat.value[2] * 255);
            return 'rgb(' + red + ', 0,' + blue + ')';
          }
        },
        data,
        type: 'scatter',
        name: visualization.name_field,
      }],
      xAxis: {
        max: maxX,
        min: minX,
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        interval: 1,
        max: labels.length + 0.5,
        splitLine: {
          show: false,
        },
        axisLabel: {
          color: '#000',
          formatter: (value) => {
            const splitted = splitWordsToLines(splitSentanceToWords(value).map((word) => ({ word })), isTextWithinLimit(253), 2);
            if (splitted[1]) {
              splitted[1] = trimDotEnd(splitted[1], isTextWithinLimit(253));
            }
            return splitted.map((f) => f.sentance).join('\n');
          },
          fontSize: 11,
        },
      },
      tooltip: {
        formatter(params) {
          return visualization.tooltip({
            ...params,
            marker: `<dt style="width:10px;height:10px;display:inline-block;margin-right:5px;">
                          <svg viewBox="0 0 12 12"><path fill="${params.color}" d="M0 0h12v12H0z"></path></svg>
                        </dt>`
          });
        }
      }
    };

    return merge(this.defaultChartOptions, options);
  }

}
